module.exports = __webpack_public_path__ + "media/images/lb/555-18740bcecffab43554485f74654afe63.svg";